
import React from 'react';

import { appMethod as app } from '@utils/app';
import { pageInstance } from '@utils/page';
import { convertStyleData } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import { RequestStatus } from 'src/common/request-status/RequestStatus';

import './NewsCustomComponent.less';

export default class NewsCustomComponent extends React.Component {
  
  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let _this = this;
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let selectedCateId = +customFeature.newsClassifyId || '';
    let initData = {};

    initData['eles[' + compindex + '].pageObj'] = {
      isLoading: false,
      noMore: false,
      page: 1
    };
    initData['eles[' + compindex + '].cdnUrl'] = app.globalData.cdnUrl;
    pageInstance.setData(initData);

    if (customFeature.isPartClassify) {
      if (!!!selectedCateId && !!!customFeature.isManualClassify) {
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppNews/GetCategoryByPage',
          data: { page: -1 },
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function (res) {
            _this.createNewsCateData(pageInstance, compindex, res.data);
          },
          fail: function () {
            _this.createNewsCateData(pageInstance, compindex, []);
          }
        });
      } else {
        _this.createNewsCateData(pageInstance, compindex, pageInstance.data.eles[compindex].content);
      }
    } else {
      pageInstance.setData({ ['eles[' + compindex + '].selectedCateId']: selectedCateId });
      _this.getNewsList({ compindex: compindex, category_id: selectedCateId, pageInstance: pageInstance, page: 1 });
    }
  }

  createNewsCateData = (pageIns, compindex, cateArr, selectedId) => {
    if (compindex < 0) {
      return;
    }
    let compContent = cateArr || [],
      pageInstance = pageIns || app.getAppCurrentPage(),
      selectId = selectedId,
      cateData = [], newData = {};
      cateData = compContent.map(cc => {
        return {
          compindex: compindex,
          id: cc.id || cc.classifyId,
          name: cc.name || cc.classifyName
        }
      });
    newData['eles[' + compindex + '].cateData'] = cateData;
    selectId || (selectId = cateData.length ? cateData[0].id : '');
    newData['eles[' + compindex + '].selectedCateId'] = selectId;
    pageInstance.setData(newData);
    this.getNewsList({ compindex: compindex, category_id: selectId, pageInstance: pageInstance, page: 1 });
  }

  getNewsList = (component_params, callback) => {
    if (typeof component_params === 'number') {
      component_params = {
        compindex: component_params
      };
    } else if (typeof component_params !== 'number' && !component_params) {
      component_params = {};
    }
    let pageInstance = component_params.pageInstance || app.getAppCurrentPage();
    // 未处理 pageInstance.newsComps
    let compindex = component_params.compindex;
    let newsData = pageInstance.data.eles[compindex];
    let cateId = component_params.category_id;
    let searchValue = component_params.search_value || '';
    let pageObj = newsData.pageObj;
    let page = component_params.page || pageObj.page || 1;
    let pageSize = component_params.page_size || newsData.customFeature.loadingNum || 10;
    let newsList = newsData.newslist || [];

    if (cateId === undefined) {
      cateId = newsData.selectedCateId;
    }

    let newdata = {};
    if(page == 1){
      newdata['eles[' + compindex + '].newslist'] = [];
      newdata['eles[' + compindex + '].pageObj.noMore'] = false;
    }
    if (pageObj.isLoading || pageObj.noMore) {
      return;
    }
    newdata['eles[' + compindex + '].pageObj.isLoading'] = true;
    newdata['eles[' + compindex + '].pageObj.loadingFail'] = false;
    pageInstance.setData(newdata);

    app.sendRequest({
      url: '/index.php?r=AppNews/GetArticleByPage',
      data: {
        category_id: cateId,
        orderby: 'add_time',
        page: page,
        search_value: searchValue,
        page_size: pageSize
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      hideLoading: true,
      success: function (res) {
        if (res.status == 0) {
          let resData = res.data,
            newData = {};

          resData = resData.map(n => {
            if (n.wechat_id) {
              return n;
            }
            if (n.form_data.url.article && n.form_data.url.article.type == 3) { //添加音乐图标
              n.form_data.url.article.cover = app.globalData.cdnUrl + '/zhichi_frontend/static/webapp/images/audio_default.png';
            }
            if (n.form_data.event.action) {
              n.event_params = n.form_data.event;
            }else {
              n.event_params = '';
            }
            if (n.article_type == 2 && n.form_data.url.article) {
              delete n.form_data.url.article.body;
            }
            if (n.content) {
              delete n.content;
            }
            if (n.form_data.recommend) {
              delete n.form_data.recommend;
            }
            if (n.media_id) { // 更换导入公众号文章展示方式
              n.style = 4;
            }
            return n;
          });

          if (pageObj.page == 1) {
            newsList = resData;
          }else {
            newsList = newsList.concat(resData);
          }

          newData['eles[' + compindex + '].newslist'] = newsList;
          pageInstance.setData(newData);

          if (res.is_more == 0) {
            pageObj.noMore = true;
          }
          pageObj.isLoading = false;
          pageObj.loadingFail = false;
          pageObj.page++;
        }
      },
      fail: function(){
        pageObj.loadingFail = true;
      },
      complete: function (res) {
        pageObj.isLoading = false;
        let newPageObj = {};
        newPageObj['eles[' + compindex + '].pageObj'] = pageObj;
        pageInstance.setData(newPageObj);
        typeof callback == 'function' && callback(res);
      }
    });
  }

  getNewsCateList = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let cateId = dataset.id;
    let pageObj = {
      isLoading: false,
      noMore: false,
      page: 1
    };
    let newData = {};

    newData['eles[' + compindex + '].pageObj'] = pageObj;
    newData['eles[' + compindex + '].selectedCateId'] = cateId;
    newData['eles[' + compindex + '].newslist'] = [];
    pageInstance.setData(newData);

    this.getNewsList({ compindex: compindex, category_id: cateId, pageInstance: pageInstance });
  }

  turnToNewsDetail = (event) => {
    if (event.currentTarget.dataset.articleType == 3) {
      let form = JSON.parse(event.currentTarget.dataset.eventParams);
      customEvent({
        customFeature: form
      })
      return;
    }
    let id = event.currentTarget.dataset.id;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    app.turnToPage('/informationManagement/pages/newsDetail/newsDetail?detail=' + id + chainParam);
  }

  _refreshNewsList = (targetCompIndex, requestData, pageInstance) => {
    pageInstance.setData({
      ['eles[' + targetCompIndex + '].pageObj']: {
        isLoading: false,
        noMore: false,
        page: 1
      },
      ['eles[' + targetCompIndex + '].selectedCateId']: requestData.idx_arr.idx_value
    });
    customComponent['news'].getNewsList({ page: 1, compid: targetCompIndex, category_id: requestData.idx_arr.idx_value });
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 用户信息
    const userInfo = pageInstance.state.userInfo || {};
    // 组件配置对象
    const customFeature = data.customFeature;
    // 分类tab样式
    const tabStyle = {
      backgroundColor: customFeature.backgroundColor,
      color: customFeature.tabTextColor,
    }
    // 选中tab样式
    const selectedStyle = {
      backgroundColor: customFeature.backgroundSelectColor,
      color: customFeature.tabTextSelectColor,
      fontWeight: 'bold',
      opacity: 1
    }
    const styleObj = convertStyleData(data.style);

    const $newsItem = (item) => (
      <React.Fragment>
        {
          (item && item.imgs && item.imgs[0] && item.style == 4 && item['article_type'] != 2) &&
          <div className="news-img-groups">
            {
              item.imgs && item.imgs.map((imgUrl, imgIdx) => (
                <div className="news-img" key={imgIdx}>
                  <img src={userInfo.cover_thumb || imgUrl} alt="" />
                  {
                    ((item['form_data']['url']['video'] && item['form_data']['url']['video']['cover']) 
                      || 
                      (item['form_data']['video'][0] && item['form_data']['video'][0]['video_url'])) &&
                    <div className="icon-wrap">
                      <label className="ico-moon icon-news-video-play"></label>
                    </div>
                  }
                </div>
              ))
            }
          </div>
        }
        {
          item.media_id &&
          <div className="news-img-groups">
            <div className={`news-img ${item.form_data.url.article.type == 3 ? 'audio-icon' : ''}`}>
              <img src={item.form_data.url.article.cover || ''} alt="" />
              {
                item.form_data.url.article.type == 4 &&
                <div className="icon-wrap">
                  <label className="ico-moon icon-news-video-play"></label>
                </div>
              }
            </div>
          </div>
        }
        <div className="news-text">
          <div className="news-title">{item.title}</div>
          {
            (item.style == 0 || item.style == 4 || item.style == 5) &&
            <div className="news-text-bottom">
              {
                item.form_data.red_package.command &&
                <img className="red-pocket-icon" src={data.cdnUrl + '/zhichi_frontend/static/webapp/images/pocket/little_pocket.png'} alt="" />
              }
              {
                item.article_type == 3 ?
                  <span className="news-adver-tag">推荐</span>
                  :
                  <span>{item.comment_count}评论</span>
              }
              <span>{item.publish_time}</span>
              {/* {
                item.article_type != 3 && item.keywords.map((word, wordIdx) => (
                  <span key={wordIdx}>#{word}</span>
                ))
              } */}
            </div>
          }
        </div>
        {
          (item && item.imgs && item.imgs[0] && item.style != 4 && item['article_type'] != 2) ?
            <div className="news-img-groups">
              {
                item.imgs && item.imgs.map((imgUrl, imgIdx) => (
                  <div className="news-img" key={imgIdx}>
                    <img src={imgUrl} mode="aspectFill" alt="" />
                    {
                      ((item['form_data']['url']['video'] && item['form_data']['url']['video']['cover']) 
                      || 
                      (item['form_data']['video'][0] && item['form_data']['video'][0]['video_url'])) &&
                      <label className="ico-moon icon-news-video-play"></label>
                    }
                  </div>
                ))
              }
            </div>
            :
            !item.media_id && item['article_type'] == 2 ?
              <div className="news-link-groups">
                {
                  item.form_data.url.article &&
                  <div className="news-article-groups">
                    <div className="img-wrap">
                      <img src={item.form_data.url.article.cover} mode="aspectFill" />
                      {
                        (item.form_data.url.article && item.form_data.url.article.type == 4) &&
                        <div className="icon-wrap">
                          <label className="ico-moon icon-news-video-play"></label>
                        </div>
                      }
                    </div>
                    <div className="title-wrap">{item.form_data.url.article.title}</div>
                  </div>
                }
                {
                  item.form_data.url.video &&
                  <div className="news-video-groups" >
                    <img src={item.form_data.url.video.cover} mode="aspectFill" />
                    {
                      ((item['form_data']['url']['video'] && item['form_data']['url']['video']['cover']) 
                      || 
                      (item['form_data']['video'][0] && item['form_data']['video'][0]['video_url'])) &&
                      <div className="icon-wrap">
                        <label className="ico-moon icon-news-video-play"></label>
                      </div>
                    }
                  </div>
                }
              </div>
              :
              null
        }
        {
          (item.style != 0 && item.style != 4 && item.style != 5) &&
          <div className="news-text-bottom">
            {
              item.form_data && item.form_data.red_package.command &&
              <img className="red-pocket-icon" src={data.cdnUrl + '/zhichi_frontend/static/webapp/images/pocket/little_pocket.png'}></img>
            }
            {
              item.article_type == 3 ?
                <span className="news-adver-tag">推荐</span>
                :
                <span>{item.comment_count}评论</span>
            }
            <span>{item.publish_time}</span>
            {/* {
              item.article_type != 3 && item.keywords.map((word, wordIdx) => (
                <span key={wordIdx}>#{word}</span>
              ))
            } */}
          </div>
        }
      </React.Fragment>
    );

    return (
      <div className="custom-component news" style={styleObj}>
        {customFeature.isPartClassify &&
          <div className="news-tab" style={tabStyle}>
            {data.cateData && data.cateData.map((cateItem) =>
              <span key={cateItem.id}
                style={data.selectedCateId === cateItem.id ? selectedStyle : {}}
                onClick={this.getNewsCateList}
                data-compindex={this.props.index}
                data-id={cateItem.id}
              >
                {cateItem.name}</span>
            )}
          </div>
        }
        <div className="news-list">
          {data.newslist && data.newslist.map((item, index) =>
            // 文章多种版式类型处理
            <div className={`news-item mode-${item.style}`} key={index}
              onClick={this.turnToNewsDetail}
              data-router="newsDetail"
              data-id={item.id}
              data-cateid={item.category_id}
              data-isliked={item.is_liked}
              data-recommend={item.is_recommend}
              data-reward={item.is_reward}
              data-article-type={item.article_type}
              data-event-params={JSON.stringify(item.event_params || {})}
            >
              {
                $newsItem(item)
              }
            </div>
          )}
          {/* 加载loading */}
          {
            data.pageObj && data.pageObj.isLoading &&
            <RequestStatus is="requestLoading"></RequestStatus>
          }
          {/* 加载没有数据 */}
          {
            data.pageObj && data.pageObj.noMore && data.newslist.length == 0 &&
            <RequestStatus is="requestNone" data={{ data: '暂无资讯文章~' }}></RequestStatus>
          }
          {/* 加载失败 */}
          {
            data.pageObj && data.pageObj.loadingFail &&
            <RequestStatus is="requestFail" data={{ refreshEvent: 'getNewsList', compindex: this.props.index }}></RequestStatus>
          }
          {/* 加载完所有数据 */}
          {
            data.pageObj && data.pageObj.noMore && data.newslist.length > 0 && data.customFeature.isShowFinishText &&
            <RequestStatus is="requestAll"></RequestStatus>
          }
          {/* loading-btn */}
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/news-custom-component/NewsCustomComponent.jsx